var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isLoading)?_c(_setup.HeadingDisplayLoader,{attrs:{"has-sub-title":false,"size":"small"}}):_c(_setup.HeadingDisplay,{attrs:{"head":"Extratos e notas","title":_setup.portfolioName,"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }